import vector1 from "../assets/images/vector1.svg"
import vector2 from "../assets/images/vector2.svg"
import vector3 from "../assets/images/vector3.svg"
import vector4 from "../assets/images/vector4.svg"
import vector5 from "../assets/images/vector5.svg"
import fb from '../assets/images/fb.png'
import insta from '../assets/images/insta.png'
import linkedin from '../assets/images/linkedin.png'
import github from '../assets/images/github.png'
import mobileMenu from "../assets/images/menu.png"
import document from "../assets/images/document.png"
import vectorLogo from "../assets/images/vectorNew.svg"
import dp from '../assets/images/dp.jpg'
import user from '../assets/images/user.png'

export const images = {
vector1:vector1,
vector2:vector2,
vector3:vector3,
vector4:vector4,
vector5:vector5,
mobileMenu: mobileMenu,
fb:fb,
insta:insta,
linkedin:linkedin,
github:github,
document:document,
vectorLogo: vectorLogo,
dp:dp,
user:user,
}